var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cat-view",on:{"click":_vm.onClick}},[_c('Cat',{staticClass:"modalCat",attrs:{"catData":_vm.catData}}),_c('h3',[_vm._v(_vm._s(_vm.catData.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }